import includes from "ramda/es/includes";
import values from "ramda/es/values";
import { GridColPosition, alignTypes, displaySizes, spaceTypes } from '../constants';
import { takeFirstKey } from '../gridUtils';
export function displaySize(propValue, key, _componentName, _location, propFullName) {
    const displaySize = propValue[key];
    if (!includes(displaySize, values(displaySizes))) {
        return new Error(`Invalid displaySize '${displaySize}' supplied to '${propFullName}'`);
    }
}
export function displaySizeAlignType(propValue, key, _componentName, _location, propFullName) {
    const displaySize = takeFirstKey(propValue[key]);
    if (!includes(displaySize, values(displaySizes))) {
        return new Error(`Invalid displaySize '${displaySize}' supplied to '${propFullName}'`);
    }
    const alignType = propValue[key][displaySize];
    if (!includes(alignType, values(alignTypes))) {
        return new Error(`Invalid alignType '${alignType}' supplied to '${propFullName}'`);
    }
}
export function displaySizeSpaceType(propValue, key, _componentName, _location, propFullName) {
    const displaySize = takeFirstKey(propValue[key]);
    if (!includes(displaySize, values(displaySizes))) {
        return new Error(`Invalid displaySize '${displaySize}' supplied to '${propFullName}'`);
    }
    const spaceType = propValue[key][displaySize];
    if (!includes(spaceType, values(spaceTypes))) {
        return new Error(`Invalid spaceType '${spaceType}' supplied to '${propFullName}'`);
    }
}
export function pushesDisplaySize(propValue, key, _componentName, _location, propFullName) {
    const displaySize = takeFirstKey(propValue[key]);
    if (!includes(displaySize, values(displaySizes))) {
        return new Error(`Invalid displaySize '${displaySize}' supplied to '${propFullName}'`);
    }
}
export function displaySizeGridColPosition(propValue, key, _componentName, _location, propFullName) {
    const displaySize = takeFirstKey(propValue[key]);
    if (!includes(displaySize, values(displaySizes))) {
        return new Error(`Invalid displaySize '${displaySize}' supplied to '${propFullName}'`);
    }
    const gridColPosition = propValue[key][displaySize];
    if (!includes(gridColPosition, values(GridColPosition))) {
        return new Error(`Invalid GridColPosition '${gridColPosition}' supplied to '${propFullName}'`);
    }
}
